import { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmissions } from "@store/action/planning/EmissionAction";
import { useTranslation } from "react-i18next";
import BreadCrumbs from "@components/breadcrumbs/index1";
import EmissionCard from "./EmissionCard";
import Filter from "./Filter";
import ReactPaginate from "react-paginate";

const Emission = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [activeView, setActiveView] = useState("list");
  const [currentPage, setCurrentPage] = useState(1);
  // ** Vars
  const store = useSelector((state) => state.emissions);
  const datas = store?.data?.data;
  const count = store.total / 5;
  useEffect(() => {
    dispatch(
      getEmissions({
        page: currentPage,
        per_page: 5,
        search: window.location.search,
      })
    );
    return () => {
      dispatch({
        type: "EMPTY_GET_EMISSIONS",
      });
    };
  }, [dispatch, window.location.search]);

  const handlePageChange = (x) => {
    setCurrentPage(x.selected + 1);
    dispatch(
      getEmissions({
        page: x.selected + 1,
        per_page: 5,
        search: window.location.search,
      })
    );
  };

  return (
    <div>
      <BreadCrumbs breadCrumbTitle={t("Emission")} />
      <div className="blog_category_wrapper blog_single_wrapper ms_cover">
        <div className="container" style={{ maxWidth: "90%" }}>
          <div className="row">
            <Filter
              t={t}
              store={store}
              dispatch={dispatch}
              setCurrentPage={setCurrentPage}
              path="emissions"
            />
            <div className="col-xl-9 col-lg-8 col-md-12 col-sm-12 col-12 shop_sidebar">
              <div className="row">
                <div className="col-md-12 d-none d-sm-none d-md-block d-lg-block">
                  <div className="filter-area ms_cover">
                    <div className="list-grid">
                      <ul className="nav nav-tabs">
                        <li className="nav-item">
                          <a
                            className="nav-link"
                            data-bs-toggle="tab"
                            onClick={() => setActiveView("grid")}
                          >
                            <i className="fas fa-th-large" />
                          </a>
                        </li>
                        <li className="nav-item">
                          <a
                            className="nav-link active"
                            data-bs-toggle="tab"
                            onClick={() => setActiveView("list")}
                          >
                            <i className="fas fa-list-ul" />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {store.data.data?.length ? (
                  <Fragment>
                    <div className="col-md-12">
                      <div className="tab-content btc_shop_index_content_tabs_main jb_cover">
                        <div id={activeView} className="tab-pane active">
                          <div className="row">
                            {datas?.map((item, i) => {
                              return (
                                <div
                                  className={
                                    activeView === "list"
                                      ? "col-lg-12 col-md-12 col-sm-12 col-12"
                                      : "col-xl-4 col-lg-4 col-md-4 col-sm-12"
                                  }
                                  key={i}
                                >
                                  <EmissionCard
                                    activeView={activeView}
                                    item={item}
                                    t={t}
                                  />
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Pagination */}
                    <div className="blog_pagination_section ms_cover">
                      <ReactPaginate
                        previousLabel={
                          <p className="prev">
                            <i className="flaticon-left-arrow" />
                          </p>
                        }
                        nextLabel={
                          <p className="next">
                            <i className="flaticon-right-arrow" />
                          </p>
                        }
                        pageRangeDisplayed={2}
                        marginPagesDisplayed={2}
                        pageCount={count || 1}
                        breakLabel="..."
                        activeClassName="third_pagger"
                        breakClassName="page-item"
                        breakLinkClassName="page-link"
                        onPageChange={(page) => handlePageChange(page)}
                        pageClassName={"page-item"}
                        containerClassName={
                          "pagination react-paginate justify-content-end p-1"
                        }
                      />
                    </div>
                  </Fragment>
                ) : (
                  <div className="d-flex justify-content-center mt-2">
                    <p>{t("No Results")}</p>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Emission;
